module.exports = __webpack_public_path__ + "img/russian-federation.383ba4c7.svg";